import { gsap } from 'gsap';

window.cart = new (function () {

    this.init = function () {

        $('body').on('click', '[data-cart-button],[data-cart-close],.cart-overlay', function (e) {
            /*e.preventDefault();
            e.stopPropagation();
            if ($('#cartAside').hasClass('open')) {
                window.cart.hideCart();
            } else {
                window.cart.showCart();
            }*/
        });
        $('body').on('click', '.shipping-calculator-button', function (e) {
            e.preventDefault();
            $('.shipping-calculator-form').slideDown(300);
        })
        $('body').on('click', '.cart-grid__item [data-spinner] [data-spinner-plus]', function (e) {
            e.preventDefault();
            e.stopPropagation();
            if ($(this).parents('[data-spinner]').find('input').val() == $(this).parents('[data-spinner]').find('input').attr('max')) {
                return false;
            } else {
                $(this).parents('[data-spinner]').find('input').val(parseInt($(this).parents('[data-spinner]').find('input').val(), 10) + 1);
                $(this).parents('[data-spinner]').find('input').trigger('change');
            }
        });
        $('body').on('click', '.cart-grid__item [data-spinner] [data-spinner-minus]', function (e) {
            e.preventDefault();
            if ($(this).parents('[data-spinner]').find('input').val() == $(this).parents('[data-spinner]').find('input').attr('max')) {
                return false;
            } else {
                $(this).parents('[data-spinner]').find('input').val(parseInt($(this).parents('[data-spinner]').find('input').val(), 10) - 1);
                $(this).parents('[data-spinner]').find('input').trigger('change');

            }
        });
        $('body').on('click', 'button[name="calc_shipping"]', function (e) {
            e.preventDefault();
            $('#cartAside').addClass('loading');
            $('<input />').attr('type', 'hidden')
                .attr('name', 'calc_shipping')
                .attr('value', 'x')
                .appendTo($('.woocommerce-shipping-calculator'));
            let data = {
                action: 'updating_shipping',
                refresh_shipping: 'yes',

            }
            window.cart.ajax(window.data.ajaxUrl + '?action=updating_shipping', $('.woocommerce-shipping-calculator').serialize());

        })
        $('body').on('click', '[data-remove-item]', function (e) {
            e.preventDefault();
            e.stopPropagation();
            let url = $(this).attr('href');
            window.cart.ajax(url);
            $('#cartAside').addClass('loading');
        })
        $('body').on('change', '[data-form-cart] input.qty', function (e) {
            $('#cartAside').addClass('loading');
            //$( document.body ).trigger( 'updated_wc_div' );
            //$( document.body ).trigger( 'updated_cart_totals' );
            let data = {
                action: 'qty_cart',
                hash: $(this).attr('name').replace(/cart\[([\w]+)\]\[qty\]/g, "$1"),
                quantity: parseFloat($(this).val()),
            }
            console.log(data);
            window.cart.ajax(window.data.ajaxUrl, data);
            //$(this).submit();
        })
        window.appEvent.listen('form:addToCart:process', this.addToCartProcessing);

        window.appEvent.listen('form:addToCart:success', this.addToCartHandler);
        $(document).off('form:updateCart:success', this.addToCartHandler).on('form:updateCart:success', this.addToCartHandler);
        $(document.body).on('updated_cart_totals', function (response) {
            console.log('respons', response)
        });
        window.cart.relatedSales() 


    }
    this.ajax = function (url, serialize) {
        $.ajax({
            type: "POST",
            url: url,
            data: serialize,
            success: function (data) {
                console.log('DATA', data);
                window.cart.updateCart(data);

            },
            error: function (data) {
                console.log(data);
            }
        });
    }
    this.timeline = gsap.timeline({ paused: true });



    this.timeline.fromTo('[data-cart-append]', .6, {
        xPercent: 100,
        ease: 'power2.inOut',

    }, {
        xPercent: 0,
        ease: 'power2.inOut',

    }, 'cartAnimation');



    this.showCart = function () {
        this.timeline.paused(false)
        this.timeline.reversed(false)
        $('#cartAside').addClass('open');
        $('.decorative-iformation').addClass('hidden');



    }
    this.hideCart = function () {
        $('#cartAside').removeClass('open');
        $('.decorative-iformation').removeClass('hidden');

        this.timeline.paused(false)
        this.timeline.reversed(true)

    }
    this.cartLoading = function () {

    }
    this.addToCartProcessing = function (data, el, response) {
        // $('#cartAside').addClass('loading');
        console.log(el);
        $(el).find('.single_add_to_cart_button').addClass('loading').prop('disabled', true)
    }
    this.addToCartHandler = function (data, response, el) {
        window.cart.updateCart(response)
        console.log(el);
        window.cart.updateNotification($(el).attr('data-product-title'), $(el).attr('data-product-cover'));

        // $('#cartAside').removeClass('loading');
        $(el).find('.single_add_to_cart_button').removeClass('loading').prop('disabled', false)
        //window.cart.showCart();


    }
    this.updateNotification = function (title, image) {
        $('[data-notification-cart]').find('[data-image]').html('<img src="' + image + '">');
        $('[data-notification-cart]').find('[data-title]').html(title);
        window.cart.showNotification();
    }
    this.showNotification = function () {
        const $notification = $('[data-notification-cart]');
        const $progressBar = $notification.find('.progress-bar');
        let notificationTimeout;

        // Réinitialiser toute notification en cours
        this.hideNotification();

        // Afficher la notification
        $notification.addClass('is-visible');

        // Déclencher l'animation de la barre de progression
        $progressBar.css('--notif-progress', '100%');

        // Configurer le timeout pour masquer après 3000ms
        notificationTimeout = setTimeout(() => {
            this.hideNotification();
        }, 3000);

        // Ajouter un gestionnaire pour le bouton de fermeture
        $notification.find('[data-close-notif]').off('click').on('click', () => {
            clearTimeout(notificationTimeout); // Annuler le timeout
            this.hideNotification();
        });

        // Stocker le timeout pour pouvoir le réinitialiser si nécessaire
        this.currentNotificationTimeout = notificationTimeout;
    };

    this.hideNotification = function () {
        const $notification = $('[data-notification-cart]');
        const $progressBar = $notification.find('.progress-bar');

        // Masquer la notification et réinitialiser la barre de progression
        $notification.removeClass('is-visible');
        $progressBar.css('--notif-progress', '0%');

        // Annuler le timeout s'il est en cours
        if (this.currentNotificationTimeout) {
            clearTimeout(this.currentNotificationTimeout);
            this.currentNotificationTimeout = null;
        }
    };

    this.updateCart = function (content) {
        if ($(content).find('.woocommerce').length) {
            console.log($(content).find('.woocommerce'))
            $('[data-cart-append]').html($(content).find('.woocommerce'));


        } else {
            $('[data-cart-append]').html(content);
        }
        if ($(content).find('[data-count-cart]').length && parseFloat($(content).find('[data-count-cart]').attr('data-count-cart')) != 0) {
            $('[data-cart-button] .cart-counter').addClass('active').html($(content).find('[data-count-cart]').attr('data-count-cart'))
            const bounce = document.querySelector('[data-cart-button] .cart-counter');
            bounce.classList.add("miniBounce");
            setTimeout(() => bounce.classList.remove('miniBounce'), 1000);



        } else {
            $('[data-cart-button] .cart-counter').removeClass('active').html('0');
            window.cart.hideCart();
        }
        
        window.appEvent.trigger('app:cart:updated');

        $('#cartAside').removeClass('loading');

    }
    this.relatedSales = function(){

            window.appEvent.listen('app:cart:updated',(data, el)=>{
                const upsell = document.getElementById('upsell-popup');

                if (upsell){
                    upsell.classList.add('show')
                    console.log("ici",upsell)
                }


            })
      
        $('body').on('change', '#upsell-form', function (e) {
           if($(this).find('input[type="checkbox"]:checked').length > 0){
                $(this).find('.btn').prop('disabled', false)

           }else{
            $(this).find('.btn').prop('disabled', true)

           }
            
        }).trigger('change')
        $('body').on('submit',"#upsell-form",function(event){
            event.preventDefault(); // Empêcher le rechargement de la page
            // Récupérer les IDs des produits sélectionnés
            var selectedProducts = [];
            var checkboxes = document.querySelectorAll('input[name="upsell_products[]"]:checked');
            checkboxes.forEach(function(checkbox) {
                selectedProducts.push(checkbox.value);
            });
        
            if (selectedProducts.length > 0) {
                $(this).addClass('loading');

                // Ajouter les produits sélectionnés au panier via AJAX
                jQuery.ajax({
                    url: window.data.ajaxUrl,
                    method: 'POST',
                    data: {
                        action: 'add_upsell_to_cart',
                        product_ids: selectedProducts
                    },
                    success: (response)=> {
                        $(this).removeClass('loading');

                        window.cart.updateNotification($(this).attr('data-global-title'), $(this).attr('data-global-cover'));
                        // Fermer la popup
                        document.getElementById('upsell-popup').classList.remove('show')
                    },
                    error: ()=> {
                        $(this).removeClass('loading');

                        alert('Une erreur est survenue, veuillez réessayer.');
                    }
                });
            } else {
                $(this).removeClass('loading');

                alert('Veuillez sélectionner au moins un produit.');
            }
        })
    }



});
